// ============================================================================
// Automatski broj lične kartice.
//
// Format: "trocifren broj / poslednje dve cifre godine"  ->  009/26, 549/26
// Kad se pređe 999, broj prelazi na četvorocifreni: 1000/26.
//
// Sledeći broj = najveći postojeći broj za tekuću godinu + 1.
// Gleda se najveći broj (a ne bukvalno poslednji upisani), da jedan pogrešan
// unos ne bi zauvek zaustavio brojač. Kad krene nova godina, broj kreće od 1.
// ============================================================================

// Poslednje dve cifre date (ili tekuće) godine, uvek dvocifreno
export const yearSuffix = (date) => {
    const y = (date instanceof Date ? date : new Date()).getFullYear();
    return String(y % 100).padStart(2, '0');
};

// Rastavlja "009/26" na { number: 9, year: '26' }; vraća null ako ne odgovara formatu
export const parseCardNumber = (value) => {
    if (!value) return null;
    const match = String(value).trim().match(/^(\d{1,})\s*\/\s*(\d{2})$/);
    if (!match) return null;
    return { number: parseInt(match[1], 10), year: match[2] };
};

// Formatira broj i godinu u "009/26" (ispod 1000 dopunjava na tri cifre)
export const formatCardNumber = (number, year) => {
    const num = number < 1000 ? String(number).padStart(3, '0') : String(number);
    return num + '/' + year;
};

// Sledeći broj kartice na osnovu spiska postojećih klijenata.
// clients: niz objekata koji imaju polje personalCardNumber
export const nextCardNumber = (clients, now) => {
    const year = yearSuffix(now);
    let maxForYear = 0;

    (Array.isArray(clients) ? clients : []).forEach((client) => {
        const parsed = parseCardNumber(client && client.personalCardNumber);
        if (parsed && parsed.year === year && parsed.number > maxForYear)
            maxForYear = parsed.number;
    });

    return formatCardNumber(maxForYear + 1, year);
};
